export default "__VITE_ASSET__CdZSD$AN__"